import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminUserService } from 'app/services/admin/user.service';
import { LocalService } from 'app/services/local.service';
import { CustomerService } from 'app/services/customer.service';

@Component({
  selector: 'app-admin-navbar',
  templateUrl: './admin-navbar.component.html',
  styleUrls: ['./admin-navbar.component.scss']
})
export class AdminNavbarComponent implements OnInit {
  isShow = false;
  isMenuOpen = false;
  isSticky = false;
  openDropdown: 'services' | 'information' | 'user' | null = null;

  constructor(
    private _loginService: CustomerService,
    private _adminUserService: AdminUserService,
    private _localService: LocalService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this._adminUserService.isLogin.subscribe((resAd) => {
      this.isShow = resAd;
      this._changeDetectorRef.markForCheck();
    });
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;

    if (!this.isMenuOpen) {
      this.openDropdown = null;
    }
  }

  closeMenu(): void {
    if (this.isDesktopView()) {
      return;
    }

    this.isMenuOpen = false;
    this.openDropdown = null;
  }

  toggleDropdown(menu: 'services' | 'information' | 'user', event: Event): void {
    if (this.isDesktopView()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.openDropdown = this.openDropdown === menu ? null : menu;
  }

  isDropdownOpen(menu: 'services' | 'information' | 'user'): boolean {
    return this.openDropdown === menu;
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!this.isDesktopView()) {
      this.isSticky = false;
      return;
    }
    this.isSticky = window.scrollY > 80;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.isDesktopView()) {
      this.isMenuOpen = false;
      this.openDropdown = null;
    } else {
      this.isSticky = false;
    }
  }

  logOut(): void {
    this._localService.clearValues();
    this._router.navigate(['/admin']);
    this._loginService.isLogin.next(false);
    this._adminUserService.isLogin.next(false);
    this.isShow = false;
    this.closeMenu();
    this._changeDetectorRef.markForCheck();
  }

  private isDesktopView(): boolean {
    return typeof window !== 'undefined' && window.innerWidth >= 992;
  }
}
